var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.BModal, {
    attrs: {
      size: "lg",
      title: "Change password",
      "modal-class": "vue-need-bootstrap",
      lazy: "",
      centered: "",
      "hide-footer": "",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ cancel }) {
          return [
            !_setup.passwordChanged
              ? _c(
                  "div",
                  [
                    _c(_setup.ValidationObserver, {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ handleSubmit, valid }) {
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return handleSubmit(
                                          _setup.changePassword
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(_setup.ValidationProvider, {
                                      attrs: {
                                        rules: "required|min:8",
                                        name: "Current password",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ valid, errors }) {
                                              return [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    staticClass: "my-3",
                                                    attrs: {
                                                      "label-cols": "3",
                                                      "content-cols": "9",
                                                      label: "Current password",
                                                      "label-for":
                                                        "current-password-input",
                                                      "invalid-feedback": _setup.invalidPassword
                                                        ? "Wrong password"
                                                        : errors[0],
                                                      state: _setup.invalidPassword
                                                        ? false
                                                        : errors[0]
                                                        ? false
                                                        : valid
                                                        ? true
                                                        : null,
                                                    },
                                                  },
                                                  [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "password",
                                                        state: _setup.invalidPassword
                                                          ? false
                                                          : errors[0]
                                                          ? false
                                                          : valid
                                                          ? true
                                                          : null,
                                                        disabled:
                                                          _setup.savingPassword,
                                                      },
                                                      model: {
                                                        value:
                                                          _setup.currentPassword,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _setup.currentPassword = $$v
                                                        },
                                                        expression:
                                                          "currentPassword",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c(_setup.ValidationProvider, {
                                      attrs: {
                                        rules: "required|min:8",
                                        name: "Password",
                                        vid: "newPassword",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ valid, errors }) {
                                              return [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    staticClass: "my-3",
                                                    attrs: {
                                                      id: "new-password-input",
                                                      "label-cols": "3",
                                                      "content-cols": "9",
                                                      label: "New password",
                                                      "label-for":
                                                        "new-password-input",
                                                      "invalid-feedback":
                                                        errors[0],
                                                      state: errors[0]
                                                        ? false
                                                        : valid
                                                        ? true
                                                        : null,
                                                    },
                                                  },
                                                  [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "password",
                                                        state: errors[0]
                                                          ? false
                                                          : valid
                                                          ? true
                                                          : null,
                                                        disabled:
                                                          _setup.savingPassword,
                                                      },
                                                      model: {
                                                        value:
                                                          _setup.newPassword,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _setup.newPassword = $$v
                                                        },
                                                        expression:
                                                          "newPassword",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c(_setup.ValidationProvider, {
                                      attrs: {
                                        rules:
                                          "required|min:8|password-confirmed:newPassword",
                                        name: "Password",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ valid, errors }) {
                                              return [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    staticClass: "my-3",
                                                    attrs: {
                                                      id:
                                                        "confirm-new-password-input",
                                                      "label-cols": "3",
                                                      "content-cols": "9",
                                                      label:
                                                        "Confirm new password",
                                                      "label-for":
                                                        "confirm-new-password-input",
                                                      "invalid-feedback":
                                                        errors[0],
                                                      state: errors[0]
                                                        ? false
                                                        : valid
                                                        ? true
                                                        : null,
                                                    },
                                                  },
                                                  [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "password",
                                                        state: errors[0]
                                                          ? false
                                                          : valid
                                                          ? true
                                                          : null,
                                                        disabled:
                                                          _setup.savingPassword,
                                                      },
                                                      model: {
                                                        value:
                                                          _setup.confirmNewPassword,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _setup.confirmNewPassword = $$v
                                                        },
                                                        expression:
                                                          "confirmNewPassword",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "error-message w-100 pb-3 text-center",
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_setup.errorMessage) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "modal-footer row pb-0" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              type: "reset",
                                              disabled: _setup.savingPassword,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return cancel()
                                              },
                                            },
                                          },
                                          [_vm._v(" Cancel ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          _setup.LoaderBtn,
                                          {
                                            attrs: {
                                              variant: "primary",
                                              type: "submit",
                                              "loading-text": "Saving",
                                              loading: _setup.savingPassword,
                                              disabled:
                                                !valid || _setup.savingPassword,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            Update password\n                        "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              : [
                  _c(
                    "div",
                    {
                      staticClass:
                        "align-items-center confirmation-message justify-content-center",
                    },
                    [_c("div", [_vm._v("Password successfully changed!")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-footer row pb-0" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _setup.onPasswordChanged()
                            },
                          },
                        },
                        [_vm._v(" Continue ")]
                      ),
                    ],
                    1
                  ),
                ],
          ]
        },
      },
    ]),
    model: {
      value: _setup.isVisible,
      callback: function ($$v) {
        _setup.isVisible = $$v
      },
      expression: "isVisible",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }